// Types
export type {
  NavItem,
  BrandConfig,
  HeaderAction,
  UserMenuItem,
  ShellConfig,
  PageMeta,
  UserInfo,
  AuthState,
  Ticket,
  TicketMessage,
  UserPreferences,
  FaqItem,
  QuickAction,
  SubscriptionData,
  SubscriptionsInfo,
  TourStep,
  TourBodyBlock,
  TourModalProps,
} from "./types";

// Icons
export { Icon } from "./icons";
export type { IconName } from "./icons";

// Context
export { AppProvider, useAppContext } from "./context";

// Hooks
export { useSidebar } from "./hooks";
export { useFeedbackTrigger } from "./hooks";
export { useRegionDisplayNames } from "./hooks";

// Utils
export { cn } from "./utils/cn";
export { getPageMeta } from "./utils/getPageMeta";
export { resolveBrand } from "./utils/resolveBrand";
export { capitalize, titleCase } from "./utils/string";

// Shell components
export {
  ShellLayout,
  LeftSidebar,
  TopHeader,
  UserDropdown,
  MobileSidebarOverlay,
  LanguageSwitcher,
  FloatingActionButton,
  QuickActionsModal,
} from "./components/shell";

// UI components
export {
  MainButton,
  StatusBadge,
  PageLayout,
  PageHeader,
  SectionCard,
  ContentGrid,
  EmptyState,
  TrustpilotFeedbackModal,
} from "./components/ui";

// Messages

// Tour
export { TourModal, TourTriggerButton } from "./components/tour";

// Integrations
export { CrispChatWidget } from "./components/integrations";
